import React, { Component } from "react";
import { connect } from "react-redux";
import { isLoggedInUser, selectUser, isAuthPending } from "../../util/selectors";
import { checkIfMobile } from "../../util";
import IntercomComponent from "react-intercom";

class Intercom extends Component {
  componentWillMount() {
    this.isMobile = checkIfMobile();
  }
  render() {
    const { user = {}, isLoggedIn, isAuthPending, currentRoutePath } = this.props;

    const isMobile = this.isMobile;
    const isPostDetailedRoute = currentRoutePath.includes("/post") || currentRoutePath.includes("/case");
    const shouldHide = isLoggedIn && isMobile && isPostDetailedRoute;
    if (isAuthPending || shouldHide) {
      return null;
    }
    if (user) {
      const { uid, name, picture, email } = user;
      return <IntercomComponent appID="uuvftv6q" user_id={uid} name={name} picture={picture} email={email} />;
    }
    return <IntercomComponent appID="uuvftv6q" />;
  }
}

const mapStateToProps = state => ({
  isLoggedIn: isLoggedInUser(state),
  isAuthPending: isAuthPending(state),
  user: selectUser(state),
  currentRoutePath: state.router.pathname,
});

export default connect(mapStateToProps)(Intercom);



// WEBPACK FOOTER //
// ./src/components/Intercom/index.js